import { defineComponent as _defineComponent } from 'vue'
import { ProfileStoreKey } from '@/models/Profile';
import useProfileState from '@/state/profile/profileState';
import ProfileSection from '@/views/profile/components/ProfileSection.vue';
import ProfileBasicEditor from '@/views/profile/components/editors/ProfileBasicEditor.vue';
import ProfileBasicView from '@/views/profile/components/views/ProfileBasicView.vue';
import ProfileInvitedBy from '@/views/profile/components/views/ProfileInvitedBy.vue';
import BCXContentArea from '@/components/molecules/BCXContentArea.vue';
import BCXBreadcrumbs from '@/components/molecules/BCXBreadcrumbs.vue';
import ProfileAboutusView from '@/views/profile/components/views/ProfileAboutusView.vue';
import ProfileMembersView from '@/views/profile/components/views/ProfileMembersView.vue';
import ProfilePublicProjectsView from '@/views/profile/components/views/ProfilePublicProjectsView.vue';
import ProfileAboutusEditor from '@/views/profile/components/editors/ProfileAboutusEditor.vue';
import ProfileCreateProjectLink from '@/views/profile/components/views/ProfileCreateProjectLink.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'ProfileCompany',
  setup(__props) {

const {
  isSelf, isEditSectionOpen, isSectionFilled,
} = useProfileState(ProfileStoreKey.PROFILE);

return { __sfc: true,isSelf, isEditSectionOpen, isSectionFilled, ProfileSection, ProfileBasicEditor, ProfileBasicView, ProfileInvitedBy, BCXContentArea, BCXBreadcrumbs, ProfileAboutusView, ProfileMembersView, ProfilePublicProjectsView, ProfileAboutusEditor, ProfileCreateProjectLink }
}

})